import { gql, useMutation } from "@apollo/client";
import { useState } from "react";
import { notify, notifyError } from "../../../../utils/toast";
import * as Sentry from "@sentry/react";
export const UPDATE_PACK = gql`
  mutation UpdatePack(
    $name: String
    $category: String
    $price: Float
    $discountPrice: Float
    $discountRate: Float
    $userPrice: Float
    $quantity: Int
    $description: String
  ) {
    updatePack(
      name: $name
      category: $category
      price: $price
      discountPrice: $discountPrice
      discountRate: $discountRate
      userPrice: $userPrice
      quantity: $quantity
      description: $description
    ) {
      id
      name
    }
  }
`;

const QuantityCounter = ({ quantity }: { quantity: number }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [count, setCount] = useState(quantity);
  const [updatePack] = useMutation(UPDATE_PACK);
  const handleCount = (type: "increase" | "decrease") => {
    setIsEditing(true);
    if (type === "increase") {
      setCount(count + 1);
    } else {
      // 카운트가 0 이하로 내려가지 않도록 조건 추가
      if (count > 1) {
        setCount(count - 1);
      }
    }
  };
  const handleSubmit = () => {
    updatePack({
      variables: {
        quantity: count,
      },
      onCompleted: () => {
        notify("팩 판매 개수가 저장되었습니다.");
        setIsEditing(false);
      },
      onError: (error) => {
        notifyError("에러가 발생했습니다. 지속될 경우 고객센터 문의 바랍니다.");
        setIsEditing(false);
        Sentry.captureException(error);
      },
    });
  };
  return (
    <div className="flex flex-col justify-center w-full">
      <hr className="my-4" />
      <h3 className="text-3xl font-bold mt-4 text-gray-800">팩 판매 개수</h3>
      <div className="flex flex-col items-center justify-center mt-6 bg-white rounded-lg p-4 pt-8 shadow-md">
        <div className="flex items-center justify-center">
          <button
            className="bg-gray-300 w-10 h-10 font-bold rounded-full text-2xl"
            onClick={() => handleCount("decrease")}
          >
            -
          </button>
          <span className="mx-4 text-4xl font-bold">{count}개</span>
          <button
            className="bg-blue-400 w-10 h-10 font-bold rounded-full text-2xl"
            onClick={() => handleCount("increase")}
          >
            +
          </button>
        </div>
        <button
          className={`w-full mt-8 bg-blue-500 text-white px-4 py-2 rounded-2xl inline-block ${
            !isEditing ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleSubmit}
          disabled={!isEditing}
        >
          적용하기
        </button>
      </div>
    </div>
  );
};

export default QuantityCounter;
